import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    fallback: String,
    removeOnError: { type: Boolean, default: false }
  }

  connect () {
    this.element.addEventListener('error', this.handleError.bind(this))
  }

  handleError (event) {
    if (this.removeOnErrorValue) {
      const container = this.furthestMatchingAncestor(this.element, '[data-image-container]')
      if (container) {
        container.remove()
      } else {
        this.element.remove()
      }
    }

    if (this.element.tagName === 'VIDEO') {
      this.replaceVideoWithImage()
    } else if (this.element.tagName === 'IMG' && !this.element.dataset.loaded) {
      this.element.src = this.fallbackValue
      this.element.dataset.loaded = 'true'
    }
  }

  replaceVideoWithImage () {
    const img = document.createElement('img')
    img.src = this.fallbackValue
    img.alt = 'Video could not be loaded'
    img.className = this.element.className
    this.element.replaceWith(img)
  }

  furthestMatchingAncestor (el, selector) {
    let match = null
    let current = el.parentElement

    while (current) {
      if (current.matches(selector)) {
        match = current
      }
      current = current.parentElement
    }

    return match
  }
}
